<template>
	<Button @click="onClick" type="success" :size="size" :disabled="disabled">
		<template #icon>
			<IconCheck :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconCheck from '../icon/IconCheck.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconCheck
	}
}
</script>
